import { BADGE_VARIANTS } from 'components/Badge'
import { type StatusBadgeMapper } from './types'

export const ACCOUNT_SET_UP_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  true: {
    variant: BADGE_VARIANTS.GREEN,
    text: 'Complete',
  },
  false: {
    variant: BADGE_VARIANTS.RED,
    text: 'Incomplete',
  },
} as const
